import styles from "./UserMessages.module.scss"

import React, { memo } from "react"

import {
  ChatDownIcon,
  Notice,
  PowerfulMessage,
  UserMessagesLayout,
} from "@shared/components"
import VirtualizedMessages from "@shared/components/chat/messages/VirtualizedMessages"
import { useChatInfo, useMessagesContext, useSchedule } from "@shared/contexts"

interface Props {
  isActive: boolean
}

function UserMessages({ isActive }: Props) {
  const { isSearchBarEnabled } = useChatInfo()
  const { schedule } = useSchedule()
  const { messages, lastStreamerMessage } = useMessagesContext()

  const scheduleId = schedule?.id

  return (
    <UserMessagesLayout
      isActive={isActive}
      mention={<div className={styles.mentionAlert} />}
      overflowStyle="hidden"
      inner={({ scrollMessages, noticeRef, messagesRef, noticeHeight }) => (
        <>
          <Notice
            isActive={!isSearchBarEnabled && Boolean(lastStreamerMessage)}
            className="fix"
            noticeRef={noticeRef}
            message={lastStreamerMessage}
          />
          <VirtualizedMessages
            messages={messages}
            messagesRef={messagesRef}
            noticeHeight={noticeHeight}
            renderMessage={(message, onMeasure) => (
              <PowerfulMessage
                key={message.key}
                scrollMessages={scrollMessages}
                message={message}
                scheduleId={scheduleId}
                onImageLoad={onMeasure}
              />
            )}
          />
          <ChatDownIcon messagesRef={messagesRef} />
        </>
      )}
    />
  )
}

export default memo(UserMessages)
